/**
 * Created by minhh on 04-May-18.
 */
import {Injectable} from '@angular/core';
import * as Numeral from 'numeral';

@Injectable()
export class N2Vi {

    private ChuSo = new Array(" không "," một "," hai "," ba "," bốn "," năm "," sáu "," bảy "," tám "," chín ");
    private Tien = new Array( "", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ");

    convert(number: number, currency: string = 'đồng', sepratorString : string = 'phẩy') {

        if(number < 0) return "Số tiền âm !";
        if(number == 0) return "Không đồng !";

        var decimal_seprator = '.';
        var split = number.toString().split(decimal_seprator);
        if (split[1] && split[1].replace(/0/g,'').trim().length > 0) {
            var word1 = this.readNumber(Number(split[0])) + ' ' + sepratorString
            var word2 = this.readNumber(Number(split[1])) + currency

            return word1 + ' ' + word2.toLowerCase();
        }
        else{
            return this.readNumber(Number(split[0])) + ' ' + currency
        }
    }

    roundTwo(number: number) {
        if (number === 0) {
            return 0;
        }
        const numberBeforeFormat = Numeral(this.moneyFormat(Math.round(number * 100) / 100));
        return numberBeforeFormat.value();
    }

    moneyFormat(numberValue: any) {
        if (numberValue === '' || numberValue === null || numberValue === undefined) {
            return '';
        }

        if (isNaN(numberValue)) {
            return 'N/A';
        }
        let numberFormat = '0,0';
        const identity = JSON.parse(JSON.parse(localStorage.getItem('jhi-authenticationinfo')));
        if (identity && identity.company) {
            numberFormat = identity.company.numberFormat;
        }
        if (!numberFormat) {
            numberFormat = '0,0';
        }         
        return Numeral(numberValue).format(numberFormat);
    }

    round(value, decimals) {
        return Number(Math.round(Number(value +'e'+ decimals)) + 'e-' + decimals);
    }

    //2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
    readNumber(numInput){
        var times=0;
        var num=0;
        var reasult="";
        var tmp="";
        var loca = new Array();

        if(numInput < 0) return "Số tiền âm !";
        if(numInput == 0) return "Không đồng !";
        if(numInput > 0) {
            num = numInput;
        }
        else {
            num = -numInput;
        }
        if (numInput > 9999999999999999) {
            // numInput = 0;
            return "Số quá lớn!";
        }

        var floor = 1000
        var i = 0
        while (num > 0){
            loca[i] = num % floor
            num = Math.floor(num / floor);
            if(isNaN(loca[i])){
                loca[i] = "0";
            }
            else {
                times = i
            }
            i++;
        }

        for (i = times; i >= 0; i--)
        {
            tmp = this.DocSo3ChuSo(loca[i]);
            reasult += tmp;
            if (loca[i] > 0) {
                if (i <= 3){
                    reasult += this.Tien[i]
                    continue
                }
                else{
                    var floorTemp = i;
                    while (floorTemp > 1) { // hàng tỷ
                        var reduct = floorTemp % 3 == 0 ? 3 : floorTemp % 3;
                        reasult += this.Tien[reduct]
                        floorTemp -= reduct
                    }
                }
            }
            if ((i > 0) && (tmp.length > 0)) reasult += ',';//&& (!string.IsNullOrEmpty(tmp))
        }
        
        if (reasult.substring(reasult.length - 1) == ',') {
            reasult = reasult.substring(0, reasult.length - 1);
        }
        reasult = reasult.substring(1,2).toUpperCase()+ reasult.substring(2);
        return reasult;//.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
    }

    //1. Hàm đọc số có ba chữ số;
    DocSo3ChuSo(baso){
        var tram;
        var chuc;
        var donvi;
        var KetQua="";
        tram = Math.floor(baso/100);
        chuc = Math.floor((baso%100)/10);
        donvi = Math.floor(baso%10);

        if(tram==0 && chuc==0 && donvi==0) return "";
        if(tram!=0) {
            KetQua += this.ChuSo[tram] + " trăm ";
            if ((chuc == 0) && (donvi != 0)) KetQua += " linh ";
        }
        if ((chuc != 0) && (chuc != 1)) {
                KetQua += this.ChuSo[chuc] + " mươi";
                if ((chuc == 0) && (donvi != 0)) KetQua = KetQua + " linh ";
        }
        if (chuc == 1) KetQua += " mười ";

        switch (donvi) {
            case 1:
                if ((chuc != 0) && (chuc != 1)) {
                    KetQua += " mốt ";
                }
                else {
                    KetQua += this.ChuSo[donvi];
                }
                break;
            case 5:
                if (chuc == 0) {
                    KetQua += this.ChuSo[donvi];
                }
                else {
                    KetQua += " lăm ";
                }
                break;
            default:
                if (donvi != 0) {
                    KetQua += this.ChuSo[donvi];
                }
                break;
            }
        return KetQua;
    }
}
